import { Trophy, Hash, Target, TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatScore } from '@/lib/utils';

interface UserRankCardProps {
    rank: number | null | undefined;
    totalScore: number | null | undefined;
    raceCount?: number;
}

export function UserRankCard({ rank, totalScore, raceCount }: UserRankCardProps) {
    const { t } = useTranslation('bets');

    if (rank == null || totalScore == null) return null;

    const avgScore = raceCount && raceCount > 0
        ? formatScore(totalScore / raceCount)
        : '–';

    return (
        <div className="bg-gradient-to-br from-emerald-500 to-emerald-700 rounded-2xl p-5 text-white shadow-lg shadow-emerald-200">
            <div className="flex items-center gap-2 mb-4">
                <Trophy size={18} className="text-emerald-200" />
                <span className="text-sm font-bold text-emerald-100">
                    {t('ranking.global.yourPosition')}
                </span>
            </div>

            <div className="grid grid-cols-3 gap-3">
                <div className="bg-white/15 rounded-xl p-3 text-center">
                    <Hash size={14} className="mx-auto mb-1 text-emerald-200" />
                    <p className="text-2xl font-black">{rank}</p>
                    <p className="text-[11px] text-emerald-200 font-medium">
                        {t('ranking.global.rank', { rank })}
                    </p>
                </div>

                <div className="bg-white/15 rounded-xl p-3 text-center">
                    <Target size={14} className="mx-auto mb-1 text-emerald-200" />
                    <p className="text-2xl font-black">{formatScore(totalScore)}</p>
                    <p className="text-[11px] text-emerald-200 font-medium">
                        {t('ranking.global.pts')}
                    </p>
                </div>

                <div className="bg-white/15 rounded-xl p-3 text-center">
                    <TrendingUp size={14} className="mx-auto mb-1 text-emerald-200" />
                    <p className="text-2xl font-black">{avgScore}</p>
                    <p className="text-[11px] text-emerald-200 font-medium">
                        {t('ranking.global.avgScore')}
                    </p>
                </div>
            </div>
        </div>
    );
}
